import React, { useState } from "react";
import "./Home.css";
import {
  Button,
  InputAdornment,
  Modal,
  TextField,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import mic from "../../assests/homeScreen/Micicon.png";
import camera from "../../assests/homeScreen/Cameraicon.png"
// import { ReactComponent as MySchool } from "../../assests/homeScreen/myschool-black-logo.svg";
import googleimg from '../../assests/homeScreen/google-img.png';
import indiabg from "../../assests/homeScreen/india-bg.png";
import searchicon from "../../assests/homeScreen/search-icon.png";
import MicIcon from '@mui/icons-material/Mic';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import CloseIcon from '@mui/icons-material/Close';
import MySchool from "../../assests/homeScreen/logonew.png";
import Microphone from "../../assests/homeScreen/Microphone.svg";
import AvatarIcon from "../../assests/header/avatar.svg";
import AvatarBlackIcon from "../../assests/auth/AvatarBlack.svg";
import { Login } from "../auth/login/Login";
import EnhancedSearch from "../search/EnhancedSearch";
import Lottie from "react-lottie";
import { navData, lottieOptions } from "./Constants.jsx";
import { SignUp } from "../auth/signUp/SignUp";
import { logoutUser } from "../../redux/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Suspense } from 'react';
import { CircularProgress, Box } from '@mui/material';
const HomeCategory = React.lazy(() => import('./HomeCategory'));
const GovImageRender = React.lazy(() => import('./GovImageRender'));
const ServiceImageRender = React.lazy(() => import('./ServiceImageRender'));

// Centered loading spinner for lazy components
const CenteredLoader = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', py: 4 }}>
    <CircularProgress size={40} sx={{ color: '#1976d2' }} />
  </Box>
);
export default function Home() {
  const { isLoggedin } = useSelector((state) => state.login);
  const [open, setOpen] = React.useState(false);
  const [tab, setTab] = React.useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchText, setSearchText] = useState("");
  const opened = Boolean(anchorEl);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleProfileClose = () => {
    setAnchorEl(null);
  };
  const userLogout = (e) => {
    dispatch(logoutUser());
    navigate("/");
  };
  const handleOpen = () => {
    if (isLoggedin) {
      userLogout();
    } else {
      setOpen(true);
      setTab(0);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setTab(0);
  };
  // Function to return Home navigational bar
  // @param none
  const navRender = () => {
    return (
      <div className="homeNavigation">
        {navData.map((key, index) => {
          return (
            <Link
              to={key.url}
              key={`nav-${index}`}
              className="homeNavigationLink"
            >
              <img
                alt={key.name.toLocaleLowerCase().replace(" ", "")}
                src={key.image}
                style={{ width: "90px" }}
              />
              <p>{key.name}</p>
            </Link>
          );
        })}
      </div>
    );
  };
  // Functions handle redirection to search page on enter press
  // @params [keycode]
  // navigate to result page send search text in url encoded format
  const handleEnterKey = (e) => {
    if (e.keyCode === 13) {
      navigate({ pathname: "/views/result", search: `?text=${searchText}` });
    }
  };
  // Function save search text field text in variable
  // @params [event] 
  const handleSearchText = (e) => {
    setSearchText(e.target.value);
  }
  // Function to clear search text
  const handleClearSearch = () => {
    setSearchText("");
  }
  const [showSearch, setShowSearch] = useState(false);
  return (
    <>
      <div className="homeContainer">
        <div className="homeHeader">

  {/* FLAG */}
  {/* <div className="indiaFlags"></div> */}

  {/* TOP NAVIGATION */}
 {/* <div className="topNavMenu">

  <div className="navDropdown">
    <Typography className="topNavItem" style={{fontSize: "16px"}}>Individuals</Typography>

    <div className="dropdownMenu">
      <ul>
        <li>Teacher</li>
        <li>Parent</li>
        <li>Student</li>
        <li>Educators</li>
        <li>Resource persons</li>
        <li>Teacher trainers</li>
        <li>Doners</li>
        <li>Free membership</li>
      </ul>
    </div>
  </div>

  <div className="navDropdown">
    <Typography className="topNavItem" style={{fontSize: "16px"}}>Businesses</Typography>

    <div className="dropdownMenu">
      <ul>
        <li>Knowledge corporates</li>
        <li>Edtech service providers</li>
        <li>Community teaching centres</li>
        <li>Publications</li>
        <li>Online/live tuition centres</li>
        <li>YouTube content makers</li>
      </ul>
    </div>
  </div>

  <div className="navDropdown">
    <Typography className="topNavItem" style={{fontSize: "16px"}}>Schools</Typography>

    <div className="dropdownMenu">
      <ul>
        <li>Government schools</li>
        <li>Private schools</li>
        <li>Aided schools</li>
        <li>Schools by foundations</li>
        <li>Donor schools</li>
      </ul>
    </div>
  </div>

  <div className="navDropdown">
    <Typography className="topNavItem" style={{fontSize: "16px"}}>Institutions</Typography>

    <div className="dropdownMenu">
      <ul>
        <li>Libraries</li>
        <li>Teacher training institutions</li>
        <li>Ngo’s</li>
        <li>CSR organizations</li>
        <li>Schools run by foundations</li>
      </ul>
    </div>
  </div>

  <div className="navDropdown">
    <Typography className="topNavItem" style={{fontSize: "16px"}}>Governments</Typography>

    <div className="dropdownMenu">
      <ul>
        <li>National council of education</li>
        <li>State education departments</li>
        <li>Govt. Funded research agencies</li>
        <li>Woman & child development</li>
        <li>ITD & similar agencies</li>
        <li>Educators of government</li>
      </ul>
    </div>
  </div>

  <div className="navDropdown">
    <Typography className="topNavItem contactUsNav" style={{ fontWeight: "bold", fontSize: "17px" }}>
    CONTACT US
  </Typography>


  <div className="dropdownMenu contactDropdownMenu">
    <div className="contactContent">
      <p>info@myschool.in</p>
      <p>888 6060 545</p>
    </div>
  </div>
</div>

</div> */}

</div>

{/* BUTTON BAR */}
{/* <div className="headerButtonBar">

  {!isLoggedin ? (
    <>
      <Button
        variant="outlined"
        className="headerActionBtn"
        onClick={handleOpen}
      >
        Log in
      </Button>

      <Button
        variant="outlined"
        className="headerActionBtn"
      >
        Download App
      </Button>

      <Button
        variant="outlined"
        className="headerActionBtn"
      >
    Join
      </Button>
    </>
  ) : (
    <div
      className="navWrapper avatarPosition"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}
    >

     
      <Button
        variant="outlined"
        className="headerActionBtn"
        onClick={() => navigate('/auth')}
      >
        Dashboard
      </Button>

     
      <Button
        variant="outlined"
        className="headerActionBtn"
        onClick={userLogout}
      >
        Sign Out
      </Button>

     
      <div className="profileLogo">
        <IconButton
          id="avatarBtn"
          aria-controls={opened ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={opened ? "true" : undefined}
          onClick={handleIconClick}
        >
          <Avatar src={opened ? AvatarBlackIcon : AvatarIcon} />
        </IconButton>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          transformOrigin={{
            horizontal: "right",
            vertical: "top"
          }}
          anchorOrigin={{
            horizontal: "right",
            vertical: "bottom"
          }}
          open={opened}
          sx={{
            ".MuiMenu-paper": {
              minWidth: 213,
              background:
                "transparent linear-gradient(180deg, #000000CC 0%, #3D3D3D99 100%) 0% 0% no-repeat padding-box",
              color: "white",
            },
          }}
          onClose={handleProfileClose}
          MenuListProps={{
            "aria-labelledby": "avatarBtn",
          }}
        >
          <MenuItem
            className="linkTypoProxima"
            onClick={() => navigate('/auth')}
          >
            Dashboard
          </MenuItem>
        </Menu>
      </div>

    </div>
  )}

</div> */}
<div className="topHeaderBar">

  {/* Logo */}
  <div className="heroLogoSection">
    <img
      src={MySchool}
      alt="MySchool"
      className="heroLogo"
    />
  </div>

  {/* Right Menu */}
 <div className="topHeaderRight">

<span 
  className="headerLink"
  onClick={() => window.open('/views/membership', '_blank')}
>
  MEMBERSHIP
</span>

  <span
  className="headerLink"
  onClick={() => window.open('/views/academic', '_blank')}
>
  RESOURCES
</span>

  {!showSearch ? (
    <>
      <img
        src={searchicon}
        alt="Search"
        className="headerSearchIcon"
        onClick={() => setShowSearch(true)}
      />

      <button className="joinBtn">Join</button>
      <button className="loginBtn">Log in</button>
      <button className="downloadBtn">Download App</button>
    </>
  ) : (
    <div className="headerSearchBox">

      <img
        src={searchicon}
        alt=""
        className="searchBoxIcon"
      />

      <input
        type="text"
        placeholder="Search myschool"
        className="headerSearchInput"
        autoFocus
      />

      {/* <MicIcon className="searchMic" /> */}

      {/* <CameraAltOutlinedIcon className="searchCamera" /> */}

      {/* <CloseIcon
        className="searchClose"
        onClick={() => setShowSearch(false)}
      /> */}
        <img
        src={mic}
        alt="Mic"
        className="searchMic"
      />
      
      <img
        src={camera}
        alt="Camera"
        className="searchCamera"
      />
        <CloseIcon
        className="searchClose"
        onClick={() => setShowSearch(false)}
      />

    </div>
  )}

  <img
    src={indiabg}
    alt="India"
    className="indiaCornerFlag"
  />

</div>

</div>
{/* //adding data beside google image 17-08-2026 */}
{/* <div>
<img src={googleimg} alt="google Img" style={{width: "30%", margin: "20px 160px 8px 0px", float: "inline-end"}} />
</div> */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "15px",
    marginTop: "20px",
    marginRight: "160px"
  }}
>
  {/* //adding data to show text in all screen first is old code 11-9 */}
  {/* <div
    style={{
      textAlign: "right",
      fontFamily: "'Poppins', sans-serif",
      //here decrese font size to 19px for mobile view 11-9
      fontSize: "28px",
      lineHeight: "1.2",
      fontWeight: 500
    }}
  >
    <div>
      <span style={{ color: "#0097df" }}>Be a partner </span>
      <span style={{ color: "#0097df" }}>of</span>
    </div>

    <div>
      <span style={{ color: "#0097df" }}>AI </span>
      <span style={{ color: "#0097df" }}>Innovation lab</span>
    </div>

    <div>
      <span style={{ color: "#0097df" }}>at </span>
      <span style={{ color: "#0097df" }}>your school</span>
    </div>
  </div> */}
    <div
  className="partnerInnovationText"
  style={{
    textAlign: "right",
    fontFamily: "'Poppins', sans-serif",
    fontSize: "28px",
    lineHeight: "1.2",
    fontWeight: 500
  }}
>
  <div>
    <span style={{ color: "#0097df" }}>Be a partner </span>
    <span style={{ color: "#0097df" }}>of</span>
  </div>

  <div>
    <span style={{ color: "#0097df" }}>AI </span>
    <span style={{ color: "#0097df" }}>Innovation lab</span>
  </div>

  <div>
    <span style={{ color: "#0097df" }}>at </span>
    <span style={{ color: "#0097df" }}>your school</span>
  </div>
</div>
  {/* //end */}
{/* //adding data to show google img responsive first code is original code 11-9 */}
  {/* <img
    src={googleimg}
    alt="Google for Education Partner"
    style={{
      width: "30%",
      height: "auto"
    }}
  /> */}
  <img
  src={googleimg}
  alt="Google for Education Partner"
  className="googlePartnerImage"
/>
  {/* //end */}
</div>
{/* //end */}

{/* SUB NAVIGATION */}
{/* <div className="subNavBar">
  <Typography>ABOUT US</Typography>
  <Typography>SERVICES</Typography>
  <Typography>GET INVOLVED</Typography>
  <Typography>RESOURCES</Typography>
  <Typography>TESTIMONIALS</Typography>
</div> */}
<div className="newHomeHero">

  

 <div className="heroContent">
  <h1>
    JOIN INDIA'S<br />
    PRIME ACADEMIC<br />
    RESOURCE HUB
  </h1>
</div>

</div>
        {/* <div className="homeContextArea">
          <div className="homeGutter"></div>
          <div className="homeCtxAreaWrapper">
            <div className="homeLogo">
            <img src={MySchool} alt="" className="myschoolHomeLogo" />
            </div>
          
            <div className="homeSearch">
              <EnhancedSearch variant="home" />
            </div>
          
            {navRender()}
          </div>
          <div className="homeGutter"></div>
        </div> */}
        <Suspense fallback={<CenteredLoader />}>
          <HomeCategory />
        </Suspense>
        <Suspense fallback={<CenteredLoader />}>
          <GovImageRender />
        </Suspense>
        <Suspense fallback={<CenteredLoader />}>
          <ServiceImageRender />
        </Suspense>
        <div className="homeFooter">
          <div className="homeGutter"></div>
          <div className="homeFooterContainer">
            <Link to={'/views/privacy'}><Typography>Privacy</Typography></Link>
            <Link to={'/views/terms'}><Typography>Terms</Typography></Link>
            <Link to={'/views/cookies'}><Typography>Cookies</Typography></Link>
            <Link to={'/views/help'}><Typography>Help</Typography></Link>
          </div>
          <div className="homeGutter"></div>
        </div>
      </div>
      {/* Render Modal for the Auth Section */}
      <Modal className="openModal" onClose={handleClose} open={open}>
        {tab === 0 ? (
          <Login changeTab={() => setTab(tab === 0 ? 1 : 0)} handleCloseModal={handleClose} />
        ) : (
          <SignUp changeTab={() => setTab(tab === 0 ? 1 : 0)} handleCloseModal={handleClose} />
        )}
      </Modal>
    </>
  );
}